import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import About from "@/components/site/About";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import FAQ from "@/components/site/FAQ";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";

function Home() {
  return (
    <div className="App" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <About />
        <Gallery />
        <FAQ />
        <BookingForm />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#5C5654",
            color: "white",
            border: "1px solid rgba(255,255,255,0.1)",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
